// extracted by mini-css-extract-plugin
export default {"contents":"jJ-z","sectionHeading":"kJ-z"};